import { FormattedMessage } from 'react-intl';

export type SettingsSection = 'account' | 'security';

interface Props {
  activeSection: SettingsSection;
  onSectionChange: (section: SettingsSection) => void;
}

function UserIcon({ className }: { className?: string }) {
  return (
    <svg className={className} fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor">
      <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 6a3.75 3.75 0 1 1-7.5 0 3.75 3.75 0 0 1 7.5 0ZM4.501 20.118a7.5 7.5 0 0 1 14.998 0A17.933 17.933 0 0 1 12 21.75c-2.676 0-5.216-.584-7.499-1.632Z" />
    </svg>
  );
}

function ShieldIcon({ className }: { className?: string }) {
  return (
    <svg className={className} fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor">
      <path strokeLinecap="round" strokeLinejoin="round" d="M9 12.75 11.25 15 15 9.75m-3-7.036A11.959 11.959 0 0 1 3.598 6 11.99 11.99 0 0 0 3 9.749c0 5.592 3.824 10.29 9 11.623 5.176-1.332 9-6.03 9-11.622 0-1.31-.21-2.571-.598-3.751h-.152c-3.196 0-6.1-1.248-8.25-3.285Z" />
    </svg>
  );
}

const sections: { id: SettingsSection; labelId: string; icon: typeof UserIcon }[] = [
  { id: 'account', labelId: 'settings.sidebar.account', icon: UserIcon },
  { id: 'security', labelId: 'settings.sidebar.security', icon: ShieldIcon },
];

export default function SettingsSidebar({ activeSection, onSectionChange }: Props) {
  return (
    <nav>
      {sections.map(({ id, labelId, icon: Icon }) => {
        const isActive = activeSection === id;
        return (
          <button
            key={id}
            type="button"
            onClick={() => onSectionChange(id)}
            aria-current={isActive ? 'page' : undefined}
            className={`flex w-full items-center gap-3 rounded-lg px-4 py-3 text-left text-sm font-medium transition-colors ${
              isActive
                ? 'bg-brand-600 text-white shadow-md'
                : 'text-slate-700 hover:bg-brand-100 hover:text-brand-800'
            }`}
          >
            <Icon className={`h-5 w-5 ${isActive ? 'text-white' : 'text-slate-400'}`} />
            <span className="flex-1">
              <FormattedMessage id={labelId} />
            </span>
            {isActive && <span aria-hidden="true">→</span>}
          </button>
        );
      })}
    </nav>
  );
}
